<script setup lang="ts"></script>

<template>
    <div class="skeleton-div">
        <div>
            <SkeletonPartsImage class="bannerCategory__img" />
        </div>
        <div class="bannerCategory__bottom">
            <SkeletonPartsText />
            <SkeletonPartsText />
        </div>
    </div>
</template>

<style scoped lang="scss">
.skeleton-div {
    position: relative;
    box-shadow: $box-shadow;
    border-radius: 10px;
    margin-bottom: 10px;
    overflow: hidden;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.bannerCategory__img {
    aspect-ratio: 16 / 9;
    width: 100%;
    height: auto;
}

.bannerCategory__bottom {
    padding: 26px 12px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 10px;
    background-color: $color-white;
}
</style>
